'use client'

import styles from './QuickView.module.scss'
import React from 'react'
import ModalQuickView from '@/entities/ModalQuickView'

export function QuickView({ productId, item }) {
    const [modalShow, setModalShow] = React.useState(false)

    const handleClick = (e) => {
        e.preventDefault()
        setModalShow(true)
    }

    return (
        <>
            <div onClick={handleClick}>
                <svg
                    className={styles.icon}
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="none"
                    viewBox="0 0 26 26"
                >
                    <rect
                        width="24.25"
                        height="24.25"
                        x="0.732"
                        y="0.398"
                        stroke="#040404"
                        strokeWidth="2"
                        rx="4.625"
                    ></rect>
                    <path
                        className={styles.path}
                        stroke="#040404"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M18.717 12.523L6.998 6.273v12.5l11.719-6.25z"
                    ></path>
                </svg>
            </div>
            {modalShow && (
                <ModalQuickView
                    productId={productId}
                    item={item}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
            )}
        </>
    )
}
